import Banner from '@carvana/ds-banner';
import React, { useEffect } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';

const impersonationWithoutConsentText = 'The customer needs to give their consent for payment.';
const impersonationWithRequestForPaymentText = 'The customer needs to initiate their payment.';
const impersonationWithDigitalWalletText =
  'The customer needs to complete their digital wallet payment.';
const impersonationText = 'Please have the customer log in and place the order.';

const getImpersonationBlockedHeadline = ({
  shouldUseDigitalWallet,
  shouldInitiateRequestForPayment
}: {
  shouldUseDigitalWallet: boolean;
  shouldInitiateRequestForPayment: boolean;
}) => {
  if (shouldUseDigitalWallet) {
    return impersonationWithDigitalWalletText;
  }

  if (shouldInitiateRequestForPayment) {
    return impersonationWithRequestForPaymentText;
  }

  return impersonationWithoutConsentText;
};

interface ImpersonationBlockedBannerProps {
  shouldUseDigitalWallet: boolean;
  shouldInitiateRequestForPayment: boolean;
  selectionType: string | undefined;
}

export const ImpersonationBlockedBanner = ({
  shouldUseDigitalWallet,
  shouldInitiateRequestForPayment,
  selectionType
}: ImpersonationBlockedBannerProps) => {
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    trackEvent('pp_complete_purchase_pao_impersonation_blocked_banner_displayed', {
      shouldUseDigitalWallet,
      shouldInitiateRequestForPayment,
      selectionType
    });
  }, [trackEvent, shouldInitiateRequestForPayment, shouldUseDigitalWallet, selectionType]);

  return (
    <Banner open type="critical" icon align="left">
      <Banner.Headline>
        {getImpersonationBlockedHeadline({
          shouldUseDigitalWallet,
          shouldInitiateRequestForPayment
        })}
      </Banner.Headline>
      <Banner.Message>{impersonationText}</Banner.Message>
    </Banner>
  );
};
